module.exports = __webpack_public_path__ + "static/media/server.52c47ee5.svg";